export const imageFields = /* groq */ `
alt,
_type,
caption,
image{
_type,
asset->{...}
}
`
